import { render, staticRenderFns } from "./agro-samples-page.vue?vue&type=template&id=ad4e8426"
import script from "./agro-samples-page.vue?vue&type=script&lang=js"
export * from "./agro-samples-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports